import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const GreyhoundIcon = observer('GreyhoundIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            className={className}
            onClick={onClick}
        >
            <mask
                id='greyhoundMask'
                width='14'
                height='14'
                x='1'
                y='1'
                maskUnits='userSpaceOnUse'
                style={{ maskType: 'alpha' }}
            >
                <path
                    fill='#142448'
                    fillRule='evenodd'
                    d='M4.087 1.4c.5.502 1.123 1.306 1.123 2.204v.347l3.47.4c.604.072 1.093.54 1.19 1.14l.128.796 3.083.38v.643c0 .7.57 1.27 1.27 1.27h.191l-.031.432a1.37 1.37 0 0 1-1.271 1.265l-6.02.408a1.93 1.93 0 0 1-1.466-.522c-.399-.373-.62-.88-.62-1.427v-.83a.39.39 0 1 0-.78 0v.83c0 .754.316 1.482.867 1.997s1.299.782 2.052.73l.069-.004v3.274H1.333v-3.592c0-2.434.97-5.796.98-5.83l.016-.053v-.717c0-.545.044-1.129.315-1.602.272-.473.37-.603.662-.93.257-.29.781-.609.781-.609m4.346 3.923a.39.39 0 1 0 0 .78.39.39 0 0 0 0-.78'
                    clipRule='evenodd'
                />
                <path
                    fill='#142448'
                    d='m14.667 6.863-.068.935h-.248a.49.49 0 0 1-.489-.488v-.546z'
                />
            </mask>
            <g mask='url(#greyhoundMask)'>
                <path
                    fill='#0b1627'
                    fillOpacity='.64'
                    d='M0 0h16v16H0z'
                />
            </g>
        </SvgElement>
    );
});
